import React from 'react';

const Brand = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4482_178)">
            <path
                d="M5.38893 6.05833C5.44774 5.60895 5.80132 5.2553 6.25071 5.19654L11.8806 4.4625C12.1883 4.42236 12.4974 4.52699 12.7169 4.74631L21.2132 13.2426C21.6037 13.6332 21.6037 14.2663 21.2132 14.6569L14.8492 21.0208C14.4587 21.4113 13.8256 21.4113 13.435 21.0208L4.9387 12.5245C4.71938 12.305 4.61476 11.996 4.65489 11.6882L5.38893 6.05833Z"
                stroke="#323232"
                strokeWidth="2"
            />
            <ellipse
                cx="10.7033"
                cy="10.5105"
                rx="1.3"
                ry="1.36364"
                transform="rotate(-45 10.7033 10.5105)"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_4482_178">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default Brand;
